const Cart = ({ color = "#0E0E0E" }: { color?: string }): React.JSX.Element => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.59458 9.89619C6.64857 9.24833 7.19016 8.75 7.84027 8.75H16.1597C16.8098 8.75 17.3514 9.24833 17.4054 9.89619L18.0721 17.8962C18.1328 18.625 17.5577 19.25 16.8264 19.25H7.1736C6.4423 19.25 5.86719 18.625 5.92792 17.8962L6.59458 9.89619Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="bevel"
      />
      <path
        d="M15 7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
    </svg>
  );
};

export default Cart;
